import { initializeApp, getApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDUlMxzYK3Rxfh86-MGCzGqdySAeDl8EBY",
  authDomain: "counselling-app-eca64.firebaseapp.com",
  projectId: "counselling-app-eca64",
  storageBucket: "counselling-app-eca64.firebasestorage.app",
  messagingSenderId: "638865252922",
  appId: "1:638865252922:web:42d26b708151edfce4cb03",
  measurementId: "G-3527TT0QQF"
};

// Initialize Firebase main app
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

/**
 * Firestore with an IndexedDB cache instead of the default in-memory one.
 *
 * Every listener in the app re-reads its whole result set when it remounts, and reads served
 * from the local cache are not billed. With persistence, a listener that comes back resumes
 * from disk and fetches only what changed since, which is the difference between paying for
 * the full collection on every navigation and paying for the delta.
 *
 * `persistentMultipleTabManager` keeps this working when the app is open in several tabs;
 * without it only the first tab gets a cache and the others silently fall back. Where
 * IndexedDB is unavailable — private windows, blocked site data — the SDK degrades to the
 * in-memory cache on its own, so this is safe to enable unconditionally.
 */
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});

// Counseling consent PDFs / images (caseConsents/{caseId}/…)
export const storage = getStorage(app);

// Initialize Cloud Functions (same region as deployed callable functions)
export const functions = getFunctions(app, 'us-central1');

// Initialize Analytics (only in browser environment)
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

// Secondary Firebase app instance for creating users without affecting main session
// This is used only for admin user creation operations
let secondaryApp: any = null;
export const getSecondaryAuth = () => {
  if (!secondaryApp) {
    // Create a secondary app instance with a unique name
    secondaryApp = initializeApp(firebaseConfig, 'secondary');
  }
  return getAuth(secondaryApp);
};

export default app;
